import { Card, Row, Col, Tag } from "antd";
import classes from "./operational.module.scss";
import { Typography } from "antd";
const { Title, Text } = Typography;

const BusinessTrends = () => {
// Dummy Business Trends
const businessTrends = [
  { title: "Spike in Workflow Automation", type: "Signal", tagColor: "blue" },
  { title: "Vendor SLA Success Rate Jumped", type: "Improvement", tagColor: "green" },
  { title: "Frequent Access to Risk Dashboard", type: "Behavior", tagColor: "purple" },
  { title: "Incident Reports Dropped by 20%", type: "Trend", tagColor: "cyan" },
  { title: "Increased Use of Mission Stack", type: "Engagement", tagColor: "gold" },
  { title: "High Activity in Operations Module", type: "Behavior", tagColor: "purple" },
];

  return (
    <>
      {" "}
      <div className={classes.header}>
        <Title level={4} style={{ marginTop: 0 }}>
          Business Trends System
        </Title>
        <Text type="secondary" style={{ fontSize: 12 }}>
          Detailed internal company signal scanner.
        </Text>
      </div>
      <div style={{ padding: "40px 20px" }}>
        <Row gutter={[16, 16]}>
          {businessTrends.map((trend, index) => (
            <Col span={6}>
              <Card key={index} hoverable>
                <div
                  style={{ display: "flex", flexDirection: "column", gap: 8 }}
                >
                  <Tag color={trend.tagColor} style={{ width: "min-content" }}>
                    {trend.type}
                  </Tag>
                  <span
                    style={{ fontSize: "16px", fontWeight: 500, marginLeft: 8 }}
                  >
                    {trend.title}
                  </span>
                </div>
              </Card>
            </Col>
          ))}
        </Row>
      </div>
    </>
  );
};
export default BusinessTrends;
